
import GiantsSlider from "@/components/GiantsSlider.vue";
import FullPicture from "@/components/FullPicture.vue";
import ArticlesLine from "@/components/ArticlesLine.vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
// import {fire, fireAuth} from '@/firebase/config'
// import { onMounted, ref, provide } from "vue";

export default {
  components: { GiantsSlider, FullPicture, ArticlesLine },
  setup() {
    const ss = useStore().state;
    const router = useRouter();
    // const sg = useStore().getters;
    ///////////////////////

    ///////////css////////////
    // css import
    // onMounted(() => {});
    ////////////////////////
    return {
      ss,
      router
    };
  }
};
